import { downgradeComponent } from '@angular/upgrade/static';

import AlertComponent from './components/alert/alert';
import CircleProgressBarComponent from './components/circleProgressBar/circleProgressBar';
import SkCircleLoader from './components/loaders/skCircleLoader/skCircleLoader';
import RootCircleLoader from './components/loaders/rootCircleLoader/rootCircleLoader';
import { dbmHideArea } from './directives/dbm-hide-area';

import { uiCodemirrorDirective } from './directives/uiCodemirrorDirective';

import { mdpReadOnlyInput } from './directives/mdp-readonly-input.directive';
import { patternInputDirective } from './directives/dbm-pattern-input.directive';
import { setMultiLineDirective } from './directives/setMultiLine';
import { autoFocusDirective } from './directives/auro-focus-directive';
import { dbmScrollToEnd } from './directives/dbmScrollToEnd';
import { sortPanel } from './directives/sortPanel';
import { lazyLoadData } from './directives/lazyLoadData';
let angularClickOutside = require('@iamadamjowett/angular-click-outside/clickoutside.directive.js');
import { IconLabelComponent } from '../shared/components/icon-label/icon-label.component';

export default angular.module('common', ['angular-click-outside'])
    .component('alert', AlertComponent)
    .directive('iconLabel', downgradeComponent({ component: IconLabelComponent }))
    .component('circleProgressBar', CircleProgressBarComponent)
    .component('skCircleLoader', SkCircleLoader)
    .component('rootCircleLoader', RootCircleLoader)
    .directive('uiCodemirrorMerge', ['$timeout', 'uiCodemirrorConfig', '$rootScope', function ($timeout, uiCodemirrorConfig, $rootScope) {
        return {
            restrict: 'EA',
            require: 'ngModel',
            compile: function compile() {
                return (scope, element, attr, ngModel) => {
                    uiCodemirrorDirective(scope, element, attr, ngModel, $rootScope, $timeout, uiCodemirrorConfig);
                }
            }
        }
    }])
    .directive('htmldiv', ['$compile', '$parse', function ($compile, $parse) {
        return {
            restrict: 'E',
            link: function (scope, element, attr) {
                element.html($parse(attr.content)(scope));
                $compile(element.contents())(scope);
            }
        }
    }])
    .directive('dbmMdpReadonlyInput', mdpReadOnlyInput)
    .directive('dbmPatternInput', patternInputDirective)
    .directive('dbmHideArea', dbmHideArea)
    .directive('setMultiLine', setMultiLineDirective)
    .directive('autoFocus', autoFocusDirective)
    .directive('dbmScrollToEnd', dbmScrollToEnd)
    .directive('sortPanel', sortPanel)
    .directive('lazyLoadData', lazyLoadData);



// WEBPACK FOOTER //
// ./src/app/common/index.js